import { useEffect, useState } from 'react';
import { useTaxApiV1 } from '../../clients/quipli-service/tax/tax-api-v1';
import { TaxCode } from '../../clients/quipli-service/tax/tax';
import { toast } from '../../util/toasts';
import { Typography } from '../../components/typography/typography';
import { Spinner } from '../../components/spinner/spinner';
import { SelectForm } from '../../components/select-form/select-form';

export const TaxCodeSelect = ({
  label,
  value,
  onChange,
}: {
  value?: string;
  onChange: (v?: string) => void;
  label?: string;
}) => {
  const [taxCodes, setTaxCodes] = useState<TaxCode[] | undefined>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { searchTaxCodes } = useTaxApiV1();

  async function init() {
    try {
      setIsLoading(true);
      const taxCodes = await searchTaxCodes({ pageSize: 1000 });
      setTaxCodes(taxCodes.items);
      setIsLoading(false);
    } catch (e) {
      toast('Unable to fetch tax codes', 'error');
    }
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="item-tax-categories container-v2">
      {!isLoading ? (
        <div className="input-group">
          <label>
            <Typography type="text-md" weight="semi-bold">
              {label || 'Tax Category'}:
            </Typography>
          </label>
          <SelectForm
            isMulti={false}
            isClearable={true}
            options={taxCodes?.map((t) => {
              return { value: t.id, label: t.name };
            })}
            value={taxCodes
              ?.map((t) => {
                return { value: t.id, label: t.name };
              })
              ?.find((t) => value === t.value)}
            onChange={(t) => onChange(t?.value)}
          />
        </div>
      ) : (
        <Spinner />
      )}
    </div>
  );
};
